module.exports = __webpack_public_path__ + "static/img/los-alegres.881aa94.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/distribution-musical/img/los-alegres.jpg
// module id = A1Lt
// module chunks = 17